import React, { useState, useEffect, useRef, useCallback } from 'react';
import passwordIcon from '../assets/icons/password.png';
import './LogPassword.css';
import './CommonDialog.css';

interface LogPasswordProps {
  onAuthenticated: () => void;
}

const LogPassword: React.FC<LogPasswordProps> = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const MAX_LENGTH = 30;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handlePasswordSubmit = useCallback(() => {
    const correctPassword = process.env.REACT_APP_DONT_LOOK_AT_SOURCECODE;
    if (password === correctPassword) {
      onAuthenticated();
    } else {
      setErrorMessage('パスワードが不正です');
    }
  }, [password, onAuthenticated]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handlePasswordSubmit();
    }
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPassword = e.target.value;
    if (newPassword.length <= MAX_LENGTH) {
      setPassword(newPassword);
    }
  };

  return (
    <div className="common-dialog-container">
      <div className="common-dialog-content">
        <div className="common-dialog-image-container">
          <img src={passwordIcon} alt="Password" className="common-dialog-image" />
        </div>
        <div className="common-dialog-right-content">
          <div className="text-input-container">
            <span className="common-dialog-message message-text">{errorMessage || 'パスワードを入力してください'}</span>
            <input
              ref={inputRef}
              type="password"
              value={password}
              onChange={handlePasswordChange}
              onKeyDown={handleKeyDown}
              className="input"
              maxLength={MAX_LENGTH}
            />
          </div>
          <button 
            className="btn-common btn-large"
            onClick={handlePasswordSubmit}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogPassword; 